import { createStyles, Theme } from '@material-ui/core/styles'

export default (theme: Theme) =>
	createStyles({
		companyBusinessRoot: {
			maxWidth: '670px',
			width: '100%',
			marginTop: '30px',
			marginBottom: '30px',
			padding: '0px 10px',
			position: 'relative',
		},
		cardRoot: {
			border: '1px solid #ebebeb',
			boxShadow: 'none',
			borderRadius: '8px',
		},
		titleSection: {
			display: 'flex',
			flexFlow: 'row',
		},
		title: {
			color: '#424242',
			fontSize: '18px',
			fontWeight: 500,
		},
		actionTitle: {
			paddingTop: 9,
			paddingRight: 5,
			marginLeft: 'auto',
			cursor: 'pointer',
		},
		cardDescription: {
			display: 'flex',
			flexFlow: 'column',
			marginBottom: '20px',
			marginTop: '5px',
			color: '#929292',
		},
		textField: {
			width: '100%',
		},
		labelTextField: {
			color: '#727272',
		},
		input: {
			color: '#424242',
			fontSize: '14px',
		},
		labelText: {
			color: '#727272',
			fontSize: '12px',
			marginBottom: '3px',
		},
		displayBlock: {
			display: 'flex',
			flexFlow: 'column',
		},
		displayNone: {
			display: 'none',
		},
		addressInfo: {
			color: '#424242',
			fontWeight: 500,
			marginTop: '5px',
		},
		formControl: {
			marginTop: '13px',
			width: '100%',
		},
		editIconLabel: {
			paddingLeft: 6,
			paddingRight: 6,
		},
		addressCardWrap: {
			paddingLeft: '0px !important',
			paddingRight: '0px !important'
		}
	})
